export const BILLING_CYCLE_OPTIONS = [
  { value: 'MONTHLY', label: 'Mensal' },
  { value: 'SEMIANNUALLY', label: 'Semestral' }
];

export const SUBSCRIPTION_STATUS_OPTIONS = [
  { value: 'active', label: 'Ativa' },
  { value: 'pending_payment', label: 'Pendente de pagamento' },
  { value: 'past_due', label: 'Em atraso' },
  { value: 'suspended', label: 'Suspensa' },
  { value: 'cancelled', label: 'Cancelada' }
];

export const ASAAS_CREATION_STATUS_OPTIONS = SUBSCRIPTION_STATUS_OPTIONS.filter((item) => item.value === 'pending_payment');
export const ASAAS_STATUS_UPDATE_OPTIONS = SUBSCRIPTION_STATUS_OPTIONS.filter((item) =>
  ['active', 'suspended', 'cancelled'].includes(item.value)
);

export const SIGNUP_STATUS_OPTIONS = [
  { value: 'checkout_created', label: 'Checkout gerado' },
  { value: 'paid', label: 'Pagamento confirmado' },
  { value: 'provisioning', label: 'Provisionando' },
  { value: 'provisioned', label: 'Provisionada' },
  { value: 'cancelled', label: 'Cancelada' },
  { value: 'expired', label: 'Expirada' },
  { value: 'failed', label: 'Falhou' }
];

export const SUBSCRIPTION_ORIGIN_OPTIONS = [
  { value: 'self_service', label: 'Self service' },
  { value: 'manual', label: 'Manual' },
  { value: 'migration', label: 'Migração' }
];

export const PROVIDER_OPTIONS = [
  { value: 'manual', label: 'Manual' },
  { value: 'asaas', label: 'Asaas' }
];

export const ADMIN_BILLING_TYPE_OPTIONS = [
  { value: 'PIX', label: 'PIX' },
  { value: 'BOLETO', label: 'Boleto' }
];

export const EVENT_PROCESSING_OPTIONS = [
  { value: 'pending', label: 'Pendente' },
  { value: 'processed', label: 'Processado' },
  { value: 'failed', label: 'Falhou' }
];

export const formatMoney = (value, currency = 'BRL') => {
  const amount = Number(value || 0);
  if (!Number.isFinite(amount)) {
    return '-';
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency || 'BRL'
  }).format(amount);
};

export const formatDateTime = (value) => {
  if (!value) {
    return '-';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleString('pt-BR');
};

export const formatDate = (value) => {
  if (!value) {
    return '-';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleDateString('pt-BR');
};

export const toDateTimeLocal = (value) => {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
};

export const toDateLocal = (value) => {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
};

export const cycleLabel = (value) => BILLING_CYCLE_OPTIONS.find((item) => item.value === value)?.label || value || '-';
export const originLabel = (value) => SUBSCRIPTION_ORIGIN_OPTIONS.find((item) => item.value === value)?.label || value || '-';
export const providerLabel = (value) => PROVIDER_OPTIONS.find((item) => item.value === value)?.label || value || '-';
export const adminBillingTypeLabel = (value) => ADMIN_BILLING_TYPE_OPTIONS.find((item) => item.value === value)?.label || value || '-';
